<template>
    <div class="Loading">
        <span />
        <b>跳转中...</b>
    </div>
</template>

<script>
export default {
    created () {
        let str = this.$route.query.nToken,
            url = window.location.host.substring(window.location.host.indexOf('.'))
        console.log(str, url)
        document.cookie = "n-token=" + str + ";path=/;domain=" + url;
        window.location.href = window.location.origin
    }
}
</script>

<style lang="scss" scoped>
.Loading {
    width: 200px;
    height: 200px;
    position: absolute;
    top: 40%;
    left: 50%;
    margin-top: -100px;
    margin-left: -100px;
    animation-name: Loxing;
    animation-duration: 2s; /*设置动画完成时间*/
    animation-iteration-count: infinite; /*设置动画无限循环运行*/
    animation-timing-function: linear; /*设置动画从头到尾的速度是相同的*/
}

.Loading > span {
    width: 100%;
    height: 100%;
    border-top: 10px solid gold;
    position: absolute;
    border-radius: 30%;
    box-sizing: border-box;
    z-index: 20;
}

.Loading:before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    border-left: 10px solid red;
    border-radius: 30%;
    transform: rotate(-30deg);
    z-index: 30;
}
.Loading:after {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    right: 0;
    border-right: 10px solid dodgerblue;
    border-radius: 30%;
    transform: rotate(30deg);
    z-index: 10;
}

@keyframes Loxing {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
.Loading > b {
    width: 100%;
    height: 100%;
    position: absolute;
    text-align: center;
    font-size: 20px;
    line-height: 200px;
    animation-name: Loading_text;
    animation-duration: 2s; /*设置动画完成时间*/
    animation-iteration-count: infinite; /*设置动画无限循环运行*/
    animation-timing-function: linear; /*设置动画从头到尾的速度是相同的*/
}
@keyframes Loading_text {
    0% {
        transform: rotate(0deg);
        color: dodgerblue;
    }
    25% {
        color: blueviolet;
    }
    50% {
        color: green;
    }
    75% {
        color: red;
    }
    100% {
        transform: rotate(-360deg);
        color: yellowgreen;
    }
}
</style>